/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnioneDto } from '../../models/unione-dto';

export interface ApiOrganicoUnioneListGet$Params {}

export function apiOrganicoUnioneListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiOrganicoUnioneListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<UnioneDto>>> {
    const rb = new RequestBuilder(rootUrl, apiOrganicoUnioneListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<UnioneDto>>;
        }),
    );
}

apiOrganicoUnioneListGet.PATH = '/api/organico/unione-list';
